import * as React from 'react';
import { ComplexValue } from 'ui';
import { mapLayoutAttributesToOptions } from './map-to-options';
import { mapOptionsToLayoutAttributes } from './map-to-attributes';
import { FlatOptions } from 'ui/common/select/flat-options/flat-options';
import { SelectType } from 'ui/common/select/types';
import { AttributeMappingType } from './constants';
import { AttributesPickerTranslation } from './types';

export interface LayoutAttributesSelectorProps {
  options: ComplexValue<any>[];
  attributesMapping: AttributeMappingType;
  layoutAttributes: { [key: string]: string | boolean };
  onChange: (value: { [key: string]: string | boolean | number }[]) => void;
  translations: Partial<AttributesPickerTranslation>;
}

export class LayoutAttributesSelector extends React.PureComponent<LayoutAttributesSelectorProps> {

  private onSelectOption = (option: ComplexValue<any>) => {

    const { options, attributesMapping, layoutAttributes } = this.props;
    const valueItems = mapLayoutAttributesToOptions(layoutAttributes, options, attributesMapping);

    const newValueItems = valueItems.some(i => i.value === option.value)
      ? valueItems.filter(i => i.value !== option.value)
      : [
        ...valueItems,
        option
      ];

    this.props.onChange(mapOptionsToLayoutAttributes(newValueItems, this.props.attributesMapping));
  };

  private onChange = (options: ComplexValue<any>[]) => {

    this.props.onChange(mapOptionsToLayoutAttributes(options, this.props.attributesMapping));
  };

  public render() {

    const { options, attributesMapping, layoutAttributes, translations } = this.props;

    const translatedOptions = options.map(item => ({
      value: item.value,
      ...(!!item.description && { description: translations[item.description] }),
      ...(item.layoutTypeContext && {layoutTypeContext: item.layoutTypeContext})
    }));

    return <div className="attributeselector">
      <FlatOptions
        options={translatedOptions}
        valueItems={mapLayoutAttributesToOptions(layoutAttributes, options, attributesMapping)}
        showIcons={false}
        selectType={SelectType.multiple}
        onSelectOption={this.onSelectOption}
        onChange={this.onChange}
        displaySelectAll={false}
      />
    </div>;
  }
}
